<!-- 美田币兑换记录- -->
<template>
    <div class="biRecord-module">
        <div class="myorderlist">
            <div class="myorderitem WhiteBg" v-for="item,index in list" :key="index" @click="toDetail(item.id)">
                <div class="header flex-row flex-between font26 gray">
                    <span class="Grey">下单时间：{{item.createDate}}</span>
                    <span class="red" v-if="item.orderStatus == 2">已发货</span>
                    <span v-if="item.orderStatus == 3">已完成</span>
                    <span v-if="item.orderStatus == 1">已下单</span>
                    <span v-if="item.orderStatus === -1">已取消</span>
                </div>
                <div class="myordercon">
                    <div class="orderitem flex-row" v-for="oItem,index in item.goods" :key="index">
                        <img class="orderimg" mode="aspectFill" :src="oItem.listImg" alt="" />
                        <div class="con flex-col margin-left-xs">
                            <div class="font30 gray ellipsis2">{{oItem.title}}</div>
                        </div>
                        <div class="price margin-left-xs">
                            <div class="font30 gray align-right" v-if="oItem.isAll != 1">{{oItem.price}}</div>
                            <div class="font30 gray align-right" v-else>1-9999</div>
                            <div class="font24 Grey align-right">
                                x {{oItem.number}}
                            </div>
                        </div>
                    </div>
                    <div class="conprice font26 gray padding-left-xs">
                        共消耗美田币: <span class="red"> {{item.goodsAmount}}</span>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="empty" style="margin-top:200px">
            <van-empty image="https://static.beautyfarm.com.cn/vip_admin/icon/empty10.png" description="您目前暂无订单" />
        </div>
    </div>
</template>

<script>
import request from "@/utils/request";
import { Toast } from 'vant'

export default {
    name: 'biRecord',
    components: {},
    data() {
        return {
            list: [], // 订单列表
            empty: false
        }
    },
    mounted() {
        this.getList();
    },
    methods: {
        // 兑换列表
        getList() {
            request({
                url: `/order/list`,
                method: "get",
            })
                .then((res) => {
                    this.list = res.data;
                    this.empty = res.data.length == 0 ? true : false
                }).catch((error) => {
                    this.list = [];
                    Toast({ position: 'top', message: error ?? '' })
                })
        },
        // 跳转
        toDetail(id) {
            this.$router.push({ name: "orderDetail", query: { id: id } });

        },
    },
}
</script>

<style  scoped lang="less">
.biRecord-module {
    height: 100%;
    overflow-y: auto;
    background: #f5f6f5;
}
.gray {
    color: #35434c;
}
.red {
    color: #ee4c4c;
}
/* 列表 */
.myorderlist {
    padding: 20px 30px 10px;
}
.myorderlist .myorderitem {
    border-radius: 12px;
    margin-bottom: 20px;
}
.myorderitem .header {
    padding: 0 30px;
    height: 96px;
    line-height: 96px;
    border-bottom: 1px solid rgba(215, 215, 215, 0.3);
}
.myorderitem .myordercon {
    padding: 30px;
    border-bottom: 1px solid rgba(215, 215, 215, 0.3);
}
.myordercon .conprice {
    text-align: right;
    line-height: 40px;
    padding-top: 20px;
}
/* 执行按钮 */
.myorderbtn {
    padding: 30px;
    justify-content: flex-end;
}
.myorderbtn button {
    width: 180px;
    text-align: center;
    border-radius: 30px;
    font-size: 26px;
    line-height: 60px;
    margin: 0;
    background-color: #ffffff;
}
.myorderbtn button.cancel {
    border: 1px solid #d7d7d7;
    color: #999999;
}
.myorderbtn button.pay {
    border: 1px solid #bc8f79;
    color: #a56b4f;
    margin-left: 20px;
}
.orderimg {
    width: 180px;
    height: 180px;
}
.orderitem .price {
    width: 140px;
    text-align: right;
    word-break: break-all;
}
.con {
    width: 256px;
}
</style>